<template>
  <section-view :title="title" :tips="tips" @tip="tip">
    <div ref="chart" class="chart"></div>
    <div class="label">
      <div>正常</div>
      <div>危险</div>
    </div>
    <span>{{description}}</span>
  </section-view>
</template>

<script>
  import SectionView from "@/components/SectionView";
  /**
   * 仪表盘卡片
   */
  export default {
    name: "GaugeCard",
    components: {SectionView},

    props: {
      // 提示
      tips: {
        type: Boolean,
        default: false
      },
      // 元素
      data: {
        type: Object,
        require: true
      }
    },

    watch: {
      data() {
        this.$nextTick(() => {
          this.update();
        });
      }
    },

    computed: {
      title() {
        return this.data ? this.data.item_dict_name: '新冠病毒易感风险'
      },
      description() {
        return this.data ? this.data.risk_description: ''
      }
    },

    mounted() {
      if (this.data != null) {
        this.update();
      }
    },

    methods: {
      // 渲染
      update() {
        let el = this.$refs.chart;
        const chart = this.$echarts.init(el);

        // 生成颜色
        const keys = ['one-fourths', 'two-fourths', 'three-fourths', 'four-fourths'], select = this.data.select_switch, options = this.data.switch_color_config;
        let colors = [];
        for (let key of keys) {
          let item = options[key];
          colors.push([item.max, item[select === key ? 'select_color' : 'no_select']]);
        }

        chart.setOption( {
          tooltip: null,
          animationDurationUpdate: 1500,
          animationEasingUpdate: 'quinticInOut',
          series: [
            {
              type: 'gauge',
              startAngle: 180,
              endAngle: 0,
              min: 0,
              max: 1,
              splitNumber: 4,
              radius: '160%',
              center: ['50%', '80%'],
              axisLine: {
                roundCap: true,
                lineStyle: {
                  width: 16,
                  color: colors
                }
              },
              axisLabel: false,
              pointer: {
                icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
                itemStyle: {
                  color: '#333'
                }
              },
              anchor: {
                show: true,
                showAbove: true,
                size: 18,
                itemStyle: {
                  borderWidth: 6,
                  borderColor: '#333'
                }
              },
              axisTick: false,
              splitLine: false,
              title: false,
              detail: false,
              data: [
                {
                  value: this.data.xg_decimal,
                }
              ]
            }
          ]
        });
      },

      tip() {
        this.$emit('tip');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .chart {
    height: 300px;
    padding-top: 20px;
  }

  span {
    display: block;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 60px;
    height: 60px;
    text-align: center;
  }
  .label {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    bottom: 120px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6B6B6B;
    line-height: 36px;
    height: 36px;
  }
</style>